<template>
  <div>
  <lk-drawer :closable="false" v-model="drawerVisible" width="405"
          @on-visible-change="onDrawerChange"
          :styles="{
            background: '#F5F5F5'
          }">
          <div class="drawer-title">
            <div class="drawer-title-word">待办消息 共{{messageSum}}条</div>
            <lk-button type="primary" @click="gotoMessagePage">待办消息中心</lk-button>
          </div>
          <div class="drawer-content">
            <MessageCard @CardChange='drawerVisible=false' title="公告消息" :contentArr="announcementData" v-if="announcementData.length"/>
            <MessageCard @CardChange='drawerVisible=false' title="待审批事务" :contentArr="approvalData" v-if="approvalData.length"/>
            <MessageCard @CardChange='drawerVisible=false' title="效期预警" :contentArr="expireWarning" v-if="expireWarning.length"/>
            <MessageCard @CardChange='drawerVisible=false' title="库存预警" :contentArr="inventoryWarning" v-if="inventoryWarning.length"/>
            <MessageCard @CardChange='drawerVisible=false' title="证件预警" :contentArr="cardWarnData" v-if="cardWarnData.length"/>
            <MessageCard @CardChange='drawerVisible=false' title="其他" :contentArr="otherData" v-if="otherData.length"/>
            <MessageCard @CardChange='drawerVisible=false' title="零售日报" :contentArr="retailDaily" v-if="retailDaily.length"/>
          </div>
        </lk-drawer>
  </div>
</template>
<script>
import MessageCard from './MessageCard';
import utils from '../../libs/utils';
import message from '../../services/message';

export default {
  name: 'MessageDrawer',
  components: { MessageCard },
  props: {
    val: {

    },
  },
  model: {
    prop: 'val',
    event: 'change',
  },
  watch: {
    val() {
      this.drawerVisible = this.val;
    },
    $route(val) {
      console.log(val);
      this.originRouteName === val.name && this.$emit('resetRoute');
      this.originRouteName = val.name;
    },
  },
  data() {
    return {
      originRouteName: '',
      drawerVisible: false,
      announcementData: [],
      approvalData: [],
      // goodsWarnData: [],
      cardWarnData: [],
      otherData: [],
      messageSum: '',
      expireWarning: [],
      inventoryWarning: [],
      retailDaily: [],
    };
  },
  methods: {
    setMessagePolling() {
      const setRolling = () => {
        // vm.MessagePolling();
        this.MessagePolling().then((res) => {
          // console.log(res);

          if (res) {
            setTimeout(() => {
              setRolling();
              // clearInterval(IntervalId);
            }, 10000);
          } else {
            this.$Message.error('失去长连接，刷新重新开始');
          }
        }).catch((err) => {
          console.log(err);

          this.$Message.error('失去长连接，刷新重新开始');
        });
      };
      setRolling();
    },
    MessagePolling() {
      console.log(1);

      return new Promise((resolve, reject) => {
        this.$store.commit('setDisableLoading', true);

        message.messagePolling().then((res) => {
          if (res.data.status === 200) {
            const data = res.data.data[1];
            // data.messageRecordMap
            let msgList = [];
            // console.log(data);
            for (const key in data) {
              const element = data[key];
              msgList = msgList.concat(element);
            }

            msgList.slice(0, 20).forEach((item, i) => {
              const vm = this;
              let path = decodeURIComponent(item.businessUrl);
              path[0] === '/' || (path = `/${path}`);
              path = utils.handleMessagePathChange(path, '/baseInfo/patient/patientEdit/', '/baseInfo/patient/patientBase/patientEdit/');
              path = utils.handleMessagePathChange(path, '/baseInfo/patient/patientCheck/', '/baseInfo/patient/patientBase/patientCheck/');
              this.$Notice.open({
                title: '您有一条待办消息',
                name: `${i}${item.businessId}`,
                duration: 0,
                render: h => h('span', {
                  style: {
                    color: '#2d8cf0',
                    cursor: 'pointer',
                  },
                  on: {
                    click: () => {
                      // console.log(path);
                      if (item.businessType === 'patient_rebuy_un_rebuy') {
                        message.messageDeal({ messageId: item.id }).then(() => {
                          // this.$router.push({ path });
                          vm.$router.push({ path });
                          vm.$Notice.close(`${i}${item.businessId}`);
                        });
                      } else {
                        vm.$router.push({ path });
                        vm.$Notice.close(`${i}${item.businessId}`);
                      }
                    },
                  },
                }, item.title),
              });
            });


            resolve(true);
          } else {
            resolve(false);
          }
        }).catch((err) => {
          utils.handleError(err);
          reject(err);
        });
      });
    },

    gotoMessagePage() {
      this.drawerVisible = false;
      this.$router.push({
        name: 'messageList',
      });
    },
    onDrawerChange(visible) {
      if (visible) {
        this.fetchMessage();
        this.fetchTabStatus();
      } else {
        this.$emit('change', visible);
      }
    },
    fetchMessage() {
      const param = {
        messageTypes: [1, 2, 3, 4, 5],
      };
      message.messageGroupList(param).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          this.announcementData = data['1'] ? data['1'] : [];
          this.approvalData = data['2'] ? data['2'] : [];
          this.cardWarnData = data['4'] ? data['4'] : [];
          this.otherData = data['5'] ? data['5'] : [];
          this.expireWarning = data['6'] ? data['6'] : [];
          this.inventoryWarning = data['7'] ? data['7'] : [];
          this.retailDaily = data['8'] ? data['8'] : [];
        } else {
          this.$Message.error(res.data.error);
        }
      })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    fetchTabStatus() {
      const param = {
        messageTypes: '1,2,4,5,6,7',
      };
      message.messageCount(param).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          this.messageSum = data.SUM;
        } else {
          this.$Message.error(res.data.error);
        }
      })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
  mounted() {
    this.setMessagePolling();
  },
};
</script>
